import { render, staticRenderFns } from "./NotificationInfo.vue?vue&type=template&id=b6e69ae0&lang=true"
import script from "./NotificationInfo.vue?vue&type=script&lang=js"
export * from "./NotificationInfo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports